(() => {
  const key = 'ew_inquiry_context_v1';
  const cleanPath = value => {
    try { const u = new URL(value, location.origin); return u.origin === location.origin ? u.origin + u.pathname : ''; } catch { return ''; }
  };
  const init = () => {
    const forms = Array.from(document.forms).filter(f => new URL(f.action, location.href).pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2,4})?(?=\/)/i, '') === '/contact');
    /* EWINALL 2026-10-16: keep going on pages without a form, so an ad click id on the landing page is remembered until the visitor reaches a form. */
    const page = cleanPath(location.href);
    const params = new URLSearchParams(location.search);
    const consent = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
    let context = {landing: page, time: Date.now()};
    const field = (form, name, value) => {
      if (!value) return;
      let input = Array.from(form.elements).find(e => e.name === name);
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.append(input); }
      input.value = value;
    };
    const refresh = () => {
      if (consent()) {
        try {
          const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
          if (saved && Date.now() - saved.time < 1800000 && cleanPath(saved.landing)) context = saved;
          ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id','gclid','gbraid','wbraid','fbclid'].forEach(k => {
            const v = params.get(k);
            if (v && v.length <= 200) context[k] = v;
          });
          sessionStorage.setItem(key, JSON.stringify(context));
        } catch {}
      } else {
        context = {landing: page, time: Date.now()};
        /* Only forget saved data once the privacy API has loaded and says no; before it loads we simply wait. */
        if (typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed === 'function') { try { sessionStorage.removeItem(key); } catch {} }
        forms.forEach(f => Array.from(f.elements).filter(e => e.dataset.ewAttribution === 'true').forEach(e => e.remove()));
      }
      forms.forEach(f => {
        field(f, 'contact[Source page]', page);
        field(f, 'contact[Previous page]', cleanPath(document.referrer));
        if (consent()) {
          Object.entries(context).filter(([k]) => k !== 'time').forEach(([k,v]) => {
            const name = 'contact[Attribution ' + k + ']'; field(f,name,v);
            Array.from(f.elements).find(e=>e.name===name).dataset.ewAttribution='true';
          });
        }
      });
    };
    refresh();
    document.addEventListener('visitorConsentCollected', refresh);
    /* EWINALL 2026-10-16: consent() is always false until the Customer Privacy API is loaded, so no ad click ids were ever saved. Load it, then re-check. */
    try { window.Shopify?.loadFeatures?.([{name: 'consent-tracking-api', version: '0.1'}], err => { if (!err) refresh(); }); } catch {}
    forms.forEach(f => f.addEventListener('submit', () => {
      refresh();
      if (!Array.from(f.elements).some(e => e.name === 'contact[Inquiry reference]')) {
        field(f, 'contact[Inquiry reference]', 'EW-' + crypto.randomUUID());
      }
    }));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();
